var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlumbing({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2832 35.5857C18.1539 30.927 25.4441 18.1112 28.8949 12.126C32.4348 18.2245 39.0791 31.199 39.0204 35.5857C38.947 41.0692 33.3072 45.5406 28.4543 45.2171C23.6014 44.8935 18.4449 41.4091 18.2832 35.5857Z",
    stroke: "#76A2D7",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlumbing);
export default __webpack_public_path__ + "static/media/Plumbing.b2062cc4939d600821847a9c47b0b3a1.svg";
export { ForwardRef as ReactComponent };